export const CM_INELIGIBILITY = 'cm_ineligibility';
export const CM_OPT_OUT = 'cm_opt_out';
export const EPISODE_END = 'episode_end';
export const CM_QUICK_ADDITION = 'cm_quick_addition';
export type REASON_TYPE = 'cm_ineligibility' | 'cm_opt_out' | 'episode_end' | 'cm_quick_addition';
